module.exports = __webpack_public_path__ + "img/LCA.1d74dd45.svg";